function init() {
  const countdownSelector = "[js-cart-countdown-timer]";
  const countdownElement = document.querySelector(countdownSelector);
  
  localStorageDateTime();

  if (!countdownElement) return;
  
  renderCountdown(countdownElement);
  
  // setEventListeners(countdownSelector);
}

// function setEventListeners(countdownSelector) {
//   waitForElement(countdownSelector).then((element) => {
//     setTimeout(() => {
//       renderCountdown(element);
//     }, "1000")
//   });
// }

function localStorageDateTime() {
  const storageKey = "cartCountdownStartTime";
  let storedTime = localStorage.getItem(storageKey);

  if (!storedTime) {
    storedTime = new Date().toISOString();
    localStorage.setItem(storageKey, storedTime);
  }

  return new Date(storedTime);
}

function waitForElement(selector, observerTarget = document.body) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }

    const observer = new MutationObserver((mutations, observer) => {
      const foundElement = document.querySelector(selector);
      if (foundElement) {
        observer.disconnect();
        return resolve(foundElement);
      }
    });

    observer.observe(observerTarget, {
      childList: true,
      subtree: true,
    });

    // If after 10 seconds the element isn't found, reject the promise
    setTimeout(() => {
      observer.disconnect();
      reject();
    }, 10000);
  });
}

function renderCountdown(container) {
  container.innerHTML = `<p class="cart-countdown-timer__message">Hurry! Your basket expires in <span id="countdown-timer"></span></p>`;

  function updateCountdown() {
    const startTime = new Date(localStorageDateTime()).getTime();
    const now = new Date().getTime();
    const countdownDuration = 15 * 60 * 1000; // 15 minutes in milliseconds
    let timeLeft = countdownDuration - ((now - startTime) % countdownDuration);

    if (now - startTime >= countdownDuration) {
      localStorage.setItem("cartCountdownStartTime", new Date().toISOString());
      timeLeft = countdownDuration;
    }

    const minutes = Math.floor(timeLeft / 60000);
    const seconds = Math.floor((timeLeft % 60000) / 1000);
    const countdownElement = document.querySelector("#countdown-timer");

    if (countdownElement) {
      countdownElement.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`;
    } else {
      console.error("Countdown element not found.");
    }

    setTimeout(updateCountdown, 1000);
  }

  updateCountdown();
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});